// Client-side cart (works logged-out on the public landing). Persists in
// localStorage and broadcasts 'reright-cart' so the nav badge / drawer update.
// Each line is { key, qty } — qty = how many instance seats of that service
// (e.g. 3 chatbots). Singleton services are pinned to qty 1 by the UI.
import { isSeated } from './serviceCatalog'

const KEY = 'reright_cart'

export function getCart() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY)) || []
    // Migrate the old string[] format → [{key, qty:1}].
    return raw.map((x) => (typeof x === 'string' ? { key: x, qty: 1 } : { key: x.key, qty: Math.max(1, x.qty | 0) }))
                .filter((x) => x.key)
  } catch { return [] }
}
function save(list) {
  // Collapse dupes, drop qty<1, clamp seated services to a sane 1..100 and
  // force singletons to 1.
  const merged = {}
  for (const { key, qty } of list) {
    if (!key) continue
    const q = isSeated(key) ? Math.min(100, Math.max(1, qty | 0)) : 1
    merged[key] = q
  }
  const out = Object.entries(merged).map(([key, qty]) => ({ key, qty }))
  try { localStorage.setItem(KEY, JSON.stringify(out)) } catch {}
  window.dispatchEvent(new Event('reright-cart'))
  return out
}
export function addToCart(key, qty = 1) {
  const c = getCart()
  const found = c.find((x) => x.key === key)
  if (found) found.qty += (isSeated(key) ? qty : 0)
  else c.push({ key, qty })
  save(c)
}
export function setQty(key, qty) {
  if (qty <= 0) { save(getCart().filter((x) => x.key !== key)); return }
  // Map in place so the line keeps its position (no jump-to-bottom on change).
  save(getCart().map((x) => (x.key === key ? { ...x, qty } : x)))
}
export function getQty(key) { return getCart().find((x) => x.key === key)?.qty || 0 }
export function removeFromCart(key) { save(getCart().filter((x) => x.key !== key)) }
export function inCart(key) { return getCart().some((x) => x.key === key) }
export function cartCount() { return getCart().reduce((n, x) => n + x.qty, 0) } // total seats
export function cartLines() { return getCart().length }                        // distinct services
export function clearCart() { save([]) }
